<template>
  <div :style="{ 'background-color': background }" class="custom-banner">
    <vs-row class="py-4">
      <vs-col vs-w="2" vs-type="flex" vs-justify="center" vs-align="center" class="p-2">
        <feather-icon :icon="icon" />
      </vs-col>
      <vs-col vs-w="10">
        <p class="text-banner">{{ text }}</p>
        <p class="text-detail">
         <slot></slot>
        </p>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
  props: {
    background: {
      type: String,
      default: 'grey',
    },
    text: {
      type: String,
      default: 'Status',
    },
    icon:{
      type: String,
      default: 'PlayIcon',
    }
  },
}
</script>

<style>
.custom-banner {
  border-radius: 5px;
  color: #fff;
}
.text-banner {
  font-size: 18px;
  font-weight: bold;
}
.text-detail {
  font-size: 10px;
  color: #fff;
  font-weight: bold;
  
}
</style>